
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restore-password",
      function () {
        return require("private-next-pages/restore-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restore-password"])
      });
    }
  